import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setToken, setUser, API_URL } from "../lib/utils";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Usar useRef para prevenir processamento duplo (StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      // Extrair session_id do hash da URL
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error("session_id não encontrado na URL");
        navigate("/login", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Enviar session_id para o backend
        const response = await fetch(`${API_URL}/api/auth/google/session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.detail || "Erro ao processar autenticação Google");
        }

        const data = await response.json();

        // Salvar token e usuário no localStorage
        setToken(data.access_token);
        setUser(data.user);

        // Redirecionar baseado no tipo de usuário
        if (data.user.is_super_admin) {
          navigate("/super-admin", { replace: true, state: { user: data.user } });
        } else {
          navigate("/dashboard", { replace: true, state: { user: data.user } });
        }
      } catch (error) {
        console.error("Erro na autenticação Google:", error);
        // Redirecionar para login com mensagem de erro
        navigate("/login", { 
          replace: true, 
          state: { error: error.message || "Erro ao fazer login com Google" } 
        });
      }
    };

    processGoogleAuth();
  }, [navigate, location.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Autenticando com Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
